
import { useSessionTimeout } from '@/hooks/useSessionTimeout';

const SessionTimeoutManager = () => {
  // This component just initializes the session timeout hook
  // It will be rendered inside the AuthProvider context
  useSessionTimeout();
  
  return null; // This component doesn't render anything
};

export default SessionTimeoutManager;
